export const Dashboard = () => import("./Dashboard.vue");
export const UserDetails = () => import("./UserDetails.vue");
export const DailyParadeSummary = () => import("./DailyParadeSummary.vue");
export const ParadePresentAbsentSummary = () => import("./ParadePresentAbsentSummary.vue");
